import { render } from "./SessionsView.vue?vue&type=template&id=37bf9157"
import script from "./SessionsView.vue?vue&type=script&lang=js"
export * from "./SessionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__